module.exports = "/_next/static/images/cc-985a76c54696f933c217f4fb6f50a93a.svg";